import { call, put } from 'redux-saga/effects';
import { questionnaireEvaluationInitializationPostSuccessAction, questionnaireEvaluationFailureAction } from '../actions';
import { QuestionnaireEvaluationInitializationService } from '../services';
export function* questionnaireEvaluationInitializationPostSaga(action, questionnaireEvaluationInitializationService = new QuestionnaireEvaluationInitializationService()) {
    try {
        const evaluationDocId = yield call({
            context: questionnaireEvaluationInitializationService,
            fn: questionnaireEvaluationInitializationService.questionnaireEvaluationInitializationPost
        }, action.payload);
        yield put(questionnaireEvaluationInitializationPostSuccessAction(evaluationDocId));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationInitializationPostSaga.js.map